// ===== CONFIGURACIÓN INICIAL =====
const STORAGE_KEY = '_sdr_x1f';

// ELIMINADO: KEY_ZCB y llamadas a zipcodebase.com
// Ahora se usa ZipLookup (zip-lookup.js) con datos locales

// Las tiendas son Shopify Pages identificadas por tener custom.get_directions,
// no productos de una coleccion. Debe coincidir con snippets/stores-preloader.liquid:
// ambos llenan la misma clave de sessionStorage con el mismo shape.
const FALLBACK_CONFIG = {
  token: 'cd854423624529a6725bbf29edfc2088',
  domain: 'c74222-e2.myshopify.com',
  apiVersion: '2026-07'
};

// Tiendas aliadas (metaobject partner_store): se leen de la Storefront API y se
// suman a ALLSTORES con isPartner: true. Van en su propia clave de
// sessionStorage, NUNCA en STORAGE_KEY: la próxima visita las cargaría como
// propias y el merge las duplicaría. Debe coincidir con _KPD en
// snippets/stores-preloader.liquid. Docs: docs/partner-stores.md
const PARTNER_STORAGE_KEY = '_sdr_x1f_pd';
// Propias en el naranja de marca (color_accent del tema), no en el rojo por
// defecto de Google, que se confunde con sus propios pines. El hover de
// ambos tipos aclara el pin con colores fijos desde JS (setPinHover); el borde
// toma el color base para que el pin no pierda definición.
const OWN_PIN = { background: '#d14200', borderColor: '#a33400', glyphColor: '#ffffff' };
const OWN_PIN_HOVER = { background: '#ff6a10', borderColor: '#d14200' };
const PARTNER_PIN = { background: '#da257f', borderColor: '#a81c61', glyphColor: '#ffffff' };
const PARTNER_PIN_HOVER = { background: '#ff3fa3', borderColor: '#da257f' };
const PARTNER_UTM = { utm_source: 'ifixandrepair', utm_medium: 'referral', utm_campaign: 'store_locator' };
// Logo de marca a la derecha del nombre: en las aliadas sustituye al badge
// "Partner Store", así que su alt conserva ese texto para lectores de pantalla.
// width/height = tamaño final (ifix 74×54 → 30 px de alto, the_fix 102×35 → 20).
const CARD_LOGOS = {
  own: { src: 'https://cdn.shopify.com/s/files/1/0574/2162/7526/files/ifix-card.png?v=1789160198', alt: 'iFixandRepair store', width: 41, height: 30 },
  partner: { src: 'https://cdn.shopify.com/s/files/1/0574/2162/7526/files/the_fix-card.png?v=1789160198', alt: 'The Fix, partner store', width: 58, height: 20 }
};
const PARTNER_STRINGS = {
  cta: 'Get a Quote',
  opensNewTab: '(opens in new tab)',
  visitPartner: 'Go to {name} page'
};

let ALLSTORES = [];
let map;
const center = { lat: 40.260, lng: -97.000 };

const nearestStores = [];
const markers = [];
// PinElement de cada tienda, indexado como markers.
const pins = [];

let submitZip = null;
let selectedPlace = null;

// ===== CARGA DE DATOS =====

function loadStoresFromCache() {
  try {
    const cached = sessionStorage.getItem(STORAGE_KEY);
    if (cached) {
      const parsed = JSON.parse(cached);
      if (Array.isArray(parsed) && parsed.length > 0) {
        ALLSTORES = parsed;
        console.info(`[find-store] 📦 ${ALLSTORES.length} tiendas desde caché`);
        return true;
      }
    }
  } catch (e) {
    console.warn('⚠️ Error reading cache:', e);
  }
  return false;
}

async function fetchStoresFallback() {
  const stores = [];
  let hasNext = true;
  let cursor = null;

  const query = `
    query getStorePages($cursor: String) {
      pages(first: 100, after: $cursor) {
        pageInfo { hasNextPage }
        edges {
          cursor
          node {
            id
            title
            handle
            locationURL: metafield(namespace: "custom", key: "get_directions") { value }
            storeAddress: metafield(namespace: "custom", key: "store_address") { value }
            zipCode: metafield(namespace: "custom", key: "zip_code") { value }
            storeEmail: metafield(namespace: "custom", key: "store_email") { value }
            storePhone: metafield(namespace: "custom", key: "store_phone_number") { value }
          }
        }
      }
    }
  `;

  try {
    while (hasNext) {
      const response = await fetch(`https://${FALLBACK_CONFIG.domain}/api/${FALLBACK_CONFIG.apiVersion}/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': FALLBACK_CONFIG.token,
        },
        body: JSON.stringify({
          query,
          variables: { cursor }
        }),
      });

      const result = await response.json();

      if (result.errors) {
        console.error('❌ GraphQL error:', result.errors);
        break;
      }

      const edges = result.data?.pages?.edges || [];

      edges.forEach(edge => {
        const processed = processStoreData(edge.node);
        if (processed) stores.push(processed);
      });

      hasNext = result.data?.pages?.pageInfo?.hasNextPage || false;
      cursor = edges.length > 0 ? edges[edges.length - 1].cursor : null;
    }

    if (stores.length > 0) {
      ALLSTORES = stores;
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stores));
      console.info(`[find-store] 🔄 ${ALLSTORES.length} tiendas desde la API (sin caché)`);
    }

  } catch (error) {
    console.error('❌ Fallback fetch failed:', error);
    throw error;
  }
}

// Recibe una Page de la Storefront API y devuelve el shape canonico de tienda,
// o null si no es una landing de tienda (sin get_directions) o sus coordenadas
// no son extraibles.
function processStoreData(page) {
  try {
    if (!page.locationURL?.value) return null;
    const coords = extractCoordsFromUrl(page.locationURL.value);
    if (!coords) return null;

    return {
      lat: coords.lat,
      lng: coords.lng,
      title: page.title || '',
      handle: page.handle || '',
      address: page.storeAddress?.value || '',
      zipCode: page.zipCode?.value || '',
      phone: page.storePhone?.value || '',
      email: page.storeEmail?.value || '',
      gmapUrl: page.locationURL.value
    };
  } catch (e) {
    return null;
  }
}

async function initStoresData() {
  if (loadStoresFromCache()) return true;
  await fetchStoresFallback();
  return ALLSTORES.length > 0;
}

// Aliadas: caché de sesión (la llena el preloader) o, en la primera visita,
// fetch propio, igual que las propias. Nunca falla hacia afuera: cualquier
// error devuelve [] y el localizador de las propias sigue igual.
async function loadPartnerStores() {
  try {
    const cached = JSON.parse(sessionStorage.getItem(PARTNER_STORAGE_KEY) || 'null');
    if (Array.isArray(cached)) {
      console.info(`[find-store] 🤝 ${cached.length} aliadas desde caché`);
      return cached;
    }
  } catch (e) {
    console.warn('⚠️ Error reading partner cache:', e);
  }

  try {
    const partners = await fetchPartnerStores();
    sessionStorage.setItem(PARTNER_STORAGE_KEY, JSON.stringify(partners));
    console.info(`[find-store] 🤝 ${partners.length} aliadas desde la API (sin caché)`);
    return partners;
  } catch (e) {
    console.warn('[find-store] ⚠️ No se pudieron cargar las aliadas: se muestran solo las propias', e);
    return [];
  }
}

async function fetchPartnerStores() {
  const partners = [];
  let hasNext = true;
  let cursor = null;

  const query = `
    query getPartners($cursor: String) {
      metaobjects(type: "partner_store", first: 250, after: $cursor) {
        pageInfo { hasNextPage endCursor }
        nodes {
          handle
          name:       field(key: "store_name")         { value }
          address:    field(key: "store_address")      { value }
          phone:      field(key: "store_phone_number") { value }
          website:    field(key: "website")            { value }
          directions: field(key: "get_directions")     { value }
          active:     field(key: "active")             { value }
        }
      }
    }
  `;

  while (hasNext) {
    const response = await fetch(`https://${FALLBACK_CONFIG.domain}/api/${FALLBACK_CONFIG.apiVersion}/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': FALLBACK_CONFIG.token,
      },
      body: JSON.stringify({ query, variables: { cursor } }),
    });

    const result = await response.json();
    // Una página a medias no se cachea: se lanza y la sesión reintenta.
    if (result.errors) throw new Error(JSON.stringify(result.errors));

    const page = result.data?.metaobjects;
    (page?.nodes || []).forEach(node => {
      const processed = processPartnerData(node);
      if (processed) partners.push(processed);
    });

    hasNext = page?.pageInfo?.hasNextPage || false;
    cursor = page?.pageInfo?.endCursor || null;
  }

  return partners;
}

// Mismas reglas que _partnerRecord() en snippets/stores-preloader.liquid (fuera
// las inactivas y las que no tienen coordenadas) y mismo shape: si cambian
// aquí, cambiarlas allí.
function processPartnerData(node) {
  if (node.active?.value === 'false') return null;
  const coords = extractCoordsFromUrl(node.directions?.value);
  if (!coords) return null;

  return {
    lat: coords.lat,
    lng: coords.lng,
    title: node.name?.value || '',
    handle: node.handle || '',
    address: node.address?.value || '',
    phone: node.phone?.value || '',
    gmapUrl: node.directions.value,
    website: node.website?.value || '',
    isPartner: true
  };
}

// ===== UTILIDADES =====

function extractCoordsFromUrl(url) {
  if (!url || typeof url !== 'string') return null;

  // !3d/!4d es la coordenada de la ficha del negocio: se prueba primero.
  // @lat,lng es el centro de la cámara del mapa, no el negocio — coincide
  // cuando la URL sale de abrir la ficha, pero si sale de una búsqueda
  // apunta al centro del área de resultados, y el desvío crece con el zoom.
  const placeMatch = url.match(/!3d(-?\d+\.\d+)!4d(-?\d+\.\d+)/);
  if (placeMatch && placeMatch.length >= 3) {
    const lat = parseFloat(placeMatch[1]);
    const lng = parseFloat(placeMatch[2]);
    if (!isNaN(lat) && !isNaN(lng)) return { lat, lng };
  }

  const viewportMatch = url.match(/@(-?\d+\.\d+),(-?\d+\.\d+)/);
  if (viewportMatch && viewportMatch.length >= 3) {
    const lat = parseFloat(viewportMatch[1]);
    const lng = parseFloat(viewportMatch[2]);
    if (!isNaN(lat) && !isNaN(lng)) return { lat, lng };
  }

  return null;
}

function getDistanceMiles(lat1, lng1, lat2, lng2) {
  const R = 3959;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLng / 2) * Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

// ===== TIENDAS CERCANAS =====

function updateNearestStores(centerPoint) {
  const centerLat = typeof centerPoint.lat === 'function' ? centerPoint.lat() : centerPoint.lat;
  const centerLng = typeof centerPoint.lng === 'function' ? centerPoint.lng() : centerPoint.lng;

  const storesWithDistance = ALLSTORES.map(store => ({
    ...store,
    distance: getDistanceMiles(centerLat, centerLng, store.lat, store.lng)
  }));

  const storesWithin30Miles = storesWithDistance.filter(store => store.distance < 30);
  storesWithin30Miles.sort((a, b) => a.distance - b.distance);

  nearestStores.length = 0;
  nearestStores.push(...storesWithin30Miles);

  showStoresHTML(nearestStores);
}

// ===== MARCADORES DEL MAPA =====

function clearMarkers() {
  markers.forEach(marker => marker.setMap(null));
  markers.length = 0;
  pins.length = 0;
}

async function addMarkersToMap() {
  try {
    clearMarkers();

    if (nearestStores.length === 0) return;

    const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker");

    nearestStores.forEach((location, index) => {
      const options = {
        position: { lat: location.lat, lng: location.lng },
        map: map,
        title: `${location.title} (${location.distance.toFixed(2)} mi)`
      };
      // Propias en naranja, aliadas en rosa. content es el PinElement mismo:
      // pin.element está deprecado en la versión de Maps que carga el tema.
      const pin = new PinElement(location.isPartner ? PARTNER_PIN : OWN_PIN);
      options.content = pin;
      const marker = new AdvancedMarkerElement(options);

      markers.push(marker);
      pins.push(pin);
      if (location.isPartner) marker.element.classList.add('marker-partner');

      // Pin → tarjeta: la tarjeta puede estar bajo el scroll de la lista. El
      // scroll espera un poco (hover intent) para que cruzar el mapa con el
      // ratón por encima de varios pines no haga saltar la lista.
      marker.element.addEventListener('mouseenter', () => {
        highlightOnly(index);
        clearTimeout(listScrollTimer);
        listScrollTimer = setTimeout(() => scrollCardIntoList(index), LIST_SCROLL_DELAY);
      });
      marker.element.addEventListener('mouseleave', () => {
        clearTimeout(listScrollTimer);
        removeHighlightStoreAndMarker(index);
      });
      marker.element.addEventListener('touchstart', (e) => {
        e.preventDefault();
        flashHighlight(index, 2000);
        scrollCardIntoList(index);
      });

      marker.element.classList.add('marker-element');
    });

    fitMapToBounds();

  } catch (error) {
    console.error('❌ Error al agregar marcadores:', error);
  }
}

// Zoom maximo al encuadrar resultados. Sin tope, una sola tienda (o dos en el
// mismo centro comercial) lleva fitBounds al zoom 22, a nivel de edificio.
const MAX_FIT_ZOOM = 15;

async function fitMapToBounds() {
  if (nearestStores.length === 0) return;
  // LatLng y LatLngBounds viven en "core", no en "maps".
  const { LatLngBounds, LatLng, event } = await google.maps.importLibrary("core");
  const bounds = new LatLngBounds();
  nearestStores.forEach(location => bounds.extend(new LatLng(location.lat, location.lng)));
  event.addListenerOnce(map, 'idle', () => {
    if (map.getZoom() > MAX_FIT_ZOOM) map.setZoom(MAX_FIT_ZOOM);
  });
  map.fitBounds(bounds);
}

// ===== BÚSQUEDA POR ZIP (REEMPLAZADA - USA DATOS LOCALES) =====

function initLocationSearchButton() {
  submitZip = document.getElementById("location-search-button");
  if (!submitZip) {
    console.error('❌ Botón location-search-button no encontrado');
    return;
  }
  submitZip.disabled = true;
  submitZip.addEventListener('click', handleLocationSearch);
}

function handleLocationSearch() {
  if (!selectedPlace || !selectedPlace.location) {
    showZipError('Please enter a valid ZIP code first');
    return;
  }

  const bloqueTexto = document.getElementById("find-store-text");
  const bloqueTiendas = document.getElementById("found-stores");

  if (bloqueTexto) {
    bloqueTexto.classList.add("hide");
    bloqueTiendas.classList.remove("hide");
  }

  try {
    if (map && selectedPlace.location) {
      map.setCenter(selectedPlace.location);
      map.setZoom(12);
      updateNearestStores(selectedPlace.location);
      addMarkersToMap();
    }

    submitZip.innerText = 'Change';
    submitZip.disabled = true;

  } catch (error) {
    console.error('❌ Error al buscar tiendas:', error);
  }
}

function enableSearchButton() {
  if (submitZip && selectedPlace && selectedPlace.location) {
    submitZip.disabled = false;
  } else if (submitZip) {
    submitZip.disabled = true;
  }
}

/**
 * REEMPLAZA: handleZipValidation (antes llamaba a la API)
 * Ahora usa ZipLookup.resolveZip() con datos locales — instantáneo, sin red
 */
function handleZipValidation(zipCode) {
  const inputElement = document.getElementById('location-search');
  hideZipError();

  const result = ZipLookup.resolveZip(zipCode);

  if (!result) {
    showZipError('Please enter a valid ZIP code');
    selectedPlace = null;
    enableSearchButton();
    return;
  }

  selectedPlace = result;

  if (inputElement) {
    inputElement.value = result.displayName;
  }

  enableSearchButton();
}

// ELIMINADO: fetchZipCoordinates (ya no se necesita)

function showZipError(message) {
  const errorElement = document.getElementById('zip-error');
  const inputElement = document.getElementById('location-search');
  if (errorElement) {
    errorElement.textContent = message;
    errorElement.classList.remove('hidden');
  }
  if (inputElement) inputElement.classList.add('error');
}

function hideZipError() {
  const errorElement = document.getElementById('zip-error');
  const inputElement = document.getElementById('location-search');
  if (errorElement) errorElement.classList.add('hidden');
  if (inputElement) inputElement.classList.remove('error');
}

// ===== RESULTADOS HTML =====

function escapeHtml(value) {
  return String(value ?? '').replace(/[&<>"']/g, c => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  }[c]));
}

// Landing de la aliada con UTM. '' si website está vacío o no es una URL:
// en ese caso la tarjeta sale sin enlaces.
function partnerUrl(store) {
  if (!store.website) return '';
  try {
    const url = new URL(store.website);
    Object.entries(PARTNER_UTM).forEach(([key, value]) => url.searchParams.set(key, value));
    url.searchParams.set('utm_content', store.handle);
    return url.toString();
  } catch (e) {
    return '';
  }
}

// Mismo icono (globo) para ir a la landing, propia o de aliada. El color lo
// pone .store-link-icon en find-store.css (tenue, pero con 3:1).
const LANDING_ICON = '<svg class="store-link-icon" xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="currentColor" aria-hidden="true" focusable="false"><path d="M325-111.5q-73-31.5-127.5-86t-86-127.5Q80-398 80-480.5t31.5-155q31.5-72.5 86-127t127.5-86Q398-880 480.5-880t155 31.5q72.5 31.5 127 86t86 127Q880-563 880-480.5T848.5-325q-31.5 73-86 127.5t-127 86Q563-80 480.5-80T325-111.5ZM480-162q26-36 45-75t31-83H404q12 44 31 83t45 75Zm-104-16q-18-33-31.5-68.5T322-320H204q29 50 72.5 87t99.5 55Zm208 0q56-18 99.5-55t72.5-87H638q-9 38-22.5 73.5T584-178ZM170-400h136q-3-20-4.5-39.5T300-480q0-21 1.5-40.5T306-560H170q-5 20-7.5 39.5T160-480q0 21 2.5 40.5T170-400Zm216 0h188q3-20 4.5-39.5T580-480q0-21-1.5-40.5T574-560H386q-3 20-4.5 39.5T380-480q0 21 1.5 40.5T386-400Zm268 0h136q5-20 7.5-39.5T800-480q0-21-2.5-40.5T790-560H654q3 20 4.5 39.5T660-480q0 21-1.5 40.5T654-400Zm-16-240h118q-29-50-72.5-87T584-782q18 33 31.5 68.5T638-640Zm-234 0h152q-12-44-31-83t-45-75q-26 36-45 75t-31 83Zm-200 0h118q9-38 22.5-73.5T376-782q-56 18-99.5 55T204-640Z"/></svg>';
const CALL_ICON ='<svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="currentColor" aria-hidden="true" focusable="false"><path d="M760-480q0-117-81.5-198.5T480-760v-80q75 0 140.5 28.5t114 77q48.5 48.5 77 114T840-480h-80Zm-160 0q0-50-35-85t-85-35v-80q83 0 141.5 58.5T680-480h-80Zm198 360q-125 0-247-54.5T329-329Q229-429 174.5-551T120-798q0-18 12-30t30-12h162q14 0 25 9.5t13 22.5l26 140q2 16-1 27t-11 19l-97 98q20 37 47.5 71.5T387-386q31 31 65 57.5t72 48.5l94-94q9-9 23.5-13.5T670-390l138 28q14 4 23 14.5t9 23.5v162q0 18-12 30t-30 12ZM241-600l66-66-17-94h-89q5 41 14 81t26 79Zm358 358q39 17 79.5 27t81.5 13v-88l-94-19-67 67ZM241-600Zm358 358Z"/></svg>';

// Tarjeta de aliada. Todo valor pasa por escapeHtml (hay un "Lee's Summit").
// El CTA es un <a> SIN la clase openQuoteMap: no abre el modal de iFix.
// rel sin noreferrer, para que The Fix vea que la visita viene de iFix.
// sponsored (no nofollow): es una referencia comercial a otra marca; iFix no
// compite con thefixsolutions.com por esas tiendas (decisión de Rony, 2026-09-11).
function partnerCardHTML(store, index) {
  const s = PARTNER_STRINGS;
  const url = escapeHtml(partnerUrl(store));
  const name = escapeHtml(store.title);
  const phone = escapeHtml(store.phone);
  const opensNewTab = escapeHtml(s.opensNewTab);
  const visit = escapeHtml(s.visitPartner.replace('{name}', store.title));

  const nameHTML = url
    ? `<a href="${url}" target="_blank" rel="noopener sponsored" data-partner-link="name" title="${visit}" aria-label="${visit} ${opensNewTab}">${name} ${LANDING_ICON}</a>`
    : name;
  const ctaHTML = url
    ? `<a href="${url}" target="_blank" rel="noopener sponsored" data-partner-link="cta" class="button medium partner-cta" aria-label="${escapeHtml(s.cta)}: ${name} ${opensNewTab}">${escapeHtml(s.cta)}</a>`
    : '';

  return `
    <article class="store-item store-item--partner" data-index="${index}">
      <header class="store-name">
        <span class="store-name__title">${nameHTML}</span>
        ${cardLogoHTML(CARD_LOGOS.partner)}
      </header>
      <div class="store-address">${escapeHtml(store.address)}</div>
      <div class="store-address store-phone">
        <a href="tel:${phone}">${phone}</a>
      </div>
      <div class="store-btns">
        <button class="button medium" data-directions="${escapeHtml(store.gmapUrl)}">Directions</button>
        ${ctaHTML}
        <a href="tel:${phone}" class="icon-button call-button" aria-label="Call ${name} at ${phone}" title="Call to this store">${CALL_ICON}</a>
      </div>
    </article>
  `;
}

function cardLogoHTML(logo) {
  return `<img class="store-name__logo" src="${logo.src}" alt="${logo.alt}" width="${logo.width}" height="${logo.height}" loading="lazy" decoding="async">`;
}

function trackPartnerClick(store, linkType) {
  if (typeof gtag !== 'function' || !store) return;
  try {
    gtag('event', 'partner_store_click', {
      store_handle: store.handle,
      store_name: store.title,
      link_type: linkType,
      distance_mi: Number(store.distance.toFixed(1))
    });
  } catch (e) {
    // Un GA roto nunca debe romper el enlace.
  }
}

// Región viva: los lectores de pantalla oyen cuántas tiendas hay tras cada
// búsqueda (propias y aliadas juntas, como se ven en la lista).
function announceResults(message) {
  let region = document.getElementById('found-stores-status');
  if (!region) {
    region = document.createElement('div');
    region.id = 'found-stores-status';
    region.className = 'sr-only';
    region.setAttribute('role', 'status');
    region.setAttribute('aria-live', 'polite');
    document.body.appendChild(region);
  }
  region.textContent = '';
  setTimeout(() => { region.textContent = message; }, 100);
}

function showStoresHTML(storesArray) {
  const storesContainer = document.getElementById("found-stores");
  if (!storesContainer) return;

  if (!storesArray || storesArray.length === 0) {
    storesContainer.innerHTML = '<p class="no-results">No stores around here yet.<br>Try entering a different ZIP code</p>';
    announceResults('No stores found near this ZIP code. Try a different ZIP code.');
    return;
  }

  announceResults(`${storesArray.length} ${storesArray.length === 1 ? 'store' : 'stores'} found near you.`);

  storesContainer.innerHTML = storesArray.map((store, index) => store.isPartner ? partnerCardHTML(store, index) : `
    <article class="store-item">
      <header class="store-name">
        <span class="store-name__title">
          <a href="/pages/${store.handle}" target="_blank" rel="noopener noreferrer" title="Go to ${store.title} page" aria-label="Go to ${store.title} page (opens in new tab)">
            ${store.title} ${LANDING_ICON}
          </a>
        </span>
        ${cardLogoHTML(CARD_LOGOS.own)}
      </header>
      <div class="store-address">${store.address}</div>
      <div class="store-address store-phone">
        <a href="tel:${store.phone}">${store.phone}</a>
      </div>
      <div class="store-btns">
        <button class="button medium" onclick="window.open('${store.gmapUrl}', '_blank')">Directions</button>
        <button data-store-title="${store.title}" data-store-zipcode="${store.zipCode}" data-store-email="${store.email}" class="button accent medium openQuoteMap" aria-label="Get a quote from ${store.title}">Get a Quote</button>
        <a href="tel:${store.phone}" class="icon-button call-button" aria-label="Call ${store.title} at ${store.phone}" title="Call to this store">
          <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="currentColor" aria-hidden="true" focusable="false"><path d="M760-480q0-117-81.5-198.5T480-760v-80q75 0 140.5 28.5t114 77q48.5 48.5 77 114T840-480h-80Zm-160 0q0-50-35-85t-85-35v-80q83 0 141.5 58.5T680-480h-80Zm198 360q-125 0-247-54.5T329-329Q229-429 174.5-551T120-798q0-18 12-30t30-12h162q14 0 25 9.5t13 22.5l26 140q2 16-1 27t-11 19l-97 98q20 37 47.5 71.5T387-386q31 31 65 57.5t72 48.5l94-94q9-9 23.5-13.5T670-390l138 28q14 4 23 14.5t9 23.5v162q0 18-12 30t-30 12ZM241-600l66-66-17-94h-89q5 41 14 81t26 79Zm358 358q39 17 79.5 27t81.5 13v-88l-94-19-67 67ZM241-600Zm358 358Z"/></svg>
        </a>
      </div>
    </article>
  `).join('');

  setTimeout(() => {
    document.querySelectorAll('.store-item').forEach((storeItem, index) => {
      storeItem.addEventListener('mouseenter', () => highlightOnly(index));
      storeItem.addEventListener('mouseleave', () => removeHighlightStoreAndMarker(index));
      storeItem.addEventListener('touchstart', () => flashHighlight(index, 2000));
      storeItem.addEventListener('click', (e) => {
        if (!e.target.classList.contains('button')) flashHighlight(index, 1500);
      });
    });
  }, 100);

  storesContainer.querySelectorAll('.openQuoteMap').forEach(button => {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      if (typeof openQuoteModal !== 'undefined') openQuoteModal(this);
    });
  });

  // Aliadas: Directions por data-attribute (no se interpola la URL en un
  // onclick) y evento GA4 en los enlaces a The Fix.
  storesContainer.querySelectorAll('.store-item--partner [data-directions]').forEach(button => {
    button.addEventListener('click', () => window.open(button.dataset.directions, '_blank'));
  });
  storesContainer.querySelectorAll('[data-partner-link]').forEach(link => {
    link.addEventListener('click', () => {
      const card = link.closest('.store-item--partner');
      trackPartnerClick(storesArray[Number(card?.dataset.index)], link.dataset.partnerLink);
    });
  });
}

// ===== HIGHLIGHT =====

const LIST_SCROLL_DELAY = 150;
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
let listScrollTimer = null;
// Un solo temporizador para el resaltado táctil: cada toque cancela el
// anterior, si no se acumulan y apagan la tarjeta equivocada a destiempo.
let highlightTimer = null;

function highlightOnly(index) {
  clearTimeout(highlightTimer);
  removeAllHighlights();
  highlightStoreAndMarker(index);
}

function flashHighlight(index, ms) {
  highlightOnly(index);
  highlightTimer = setTimeout(() => removeHighlightStoreAndMarker(index), ms);
}

// Centra la tarjeta dentro de #found-stores si no se ve entera. Solo mueve la
// lista: scrollIntoView() arrastraría también la página.
function scrollCardIntoList(index) {
  const list = document.getElementById('found-stores');
  const card = document.querySelectorAll('.store-item')[index];
  if (!list || !card) return;

  const listRect = list.getBoundingClientRect();
  const cardRect = card.getBoundingClientRect();
  if (cardRect.top >= listRect.top && cardRect.bottom <= listRect.bottom) return;

  const top = list.scrollTop + (cardRect.top - listRect.top) - (list.clientHeight - cardRect.height) / 2;
  list.scrollTo({ top, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
}

function setPinHover(index, on) {
  const pin = pins[index];
  if (!pin) return;
  const partner = nearestStores[index]?.isPartner;
  const colors = on
    ? (partner ? PARTNER_PIN_HOVER : OWN_PIN_HOVER)
    : (partner ? PARTNER_PIN : OWN_PIN);
  pin.background = colors.background;
  pin.borderColor = colors.borderColor;
}

function highlightStoreAndMarker(index) {
  const storeItems = document.querySelectorAll('.store-item');
  if (storeItems[index]) storeItems[index].classList.add('highlighted');
  if (markers[index]?.element) markers[index].element.classList.add('marker-highlighted');
  setPinHover(index, true);
}

function removeHighlightStoreAndMarker(index) {
  const storeItems = document.querySelectorAll('.store-item');
  if (storeItems[index]) storeItems[index].classList.remove('highlighted');
  if (markers[index]?.element) markers[index].element.classList.remove('marker-highlighted');
  setPinHover(index, false);
}

function removeAllHighlights() {
  document.querySelectorAll('.store-item').forEach(item => item.classList.remove('highlighted'));
  markers.forEach(marker => marker.element?.classList.remove('marker-highlighted'));
  pins.forEach((pin, index) => setPinHover(index, false));
}

// ===== MAPA =====

window.initMap = async () => {
  try {
    const { Map } = await google.maps.importLibrary("maps");
    map = new Map(document.getElementById("map"), {
      center,
      zoom: 4,
      mapId: "FIND_STORE",
      zoomControl: true,
      cameraControl: false,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: true
    });
  } catch (error) {
    console.error('❌ Error al inicializar el mapa:', error);
  }
};

// ===== URL PARAM =====

function getZipcodeFromURL() {
  const urlParams = new URLSearchParams(window.location.search);
  const zipcode = urlParams.get('zipcode');
  return (zipcode && /^\d{5}$/.test(zipcode)) ? zipcode : null;
}

/**
 * REEMPLAZA: handleAutoSearch (antes asíncrono por la API)
 * Ahora es síncrono — ZipLookup es instantáneo
 */
function handleAutoSearch(zipCode) {
  const inputElement = document.getElementById('location-search');
  const bloqueTexto = document.getElementById("find-store-text");
  const bloqueTiendas = document.getElementById("found-stores");

  if (bloqueTexto) bloqueTexto.classList.add("hide");
  if (bloqueTiendas) bloqueTiendas.classList.remove("hide");

  const result = ZipLookup.resolveZip(zipCode);

  if (!result) {
    showZipError('Please enter a valid ZIP code');
    if (bloqueTexto) bloqueTexto.classList.remove("hide");
    if (bloqueTiendas) bloqueTiendas.classList.add("hide");
    return;
  }

  selectedPlace = result;
  if (inputElement) inputElement.value = result.displayName;

  if (map && selectedPlace.location) {
    map.setCenter(selectedPlace.location);
    map.setZoom(12);
    updateNearestStores(selectedPlace.location);
    addMarkersToMap();
  }

  if (submitZip) {
    submitZip.innerText = 'Change';
    submitZip.disabled = true;
  }
}

// ===== META PIXEL: TRACKEO DE BOTONES DE LLAMADA =====
// Delegación en `document` para capturar CUALQUIER enlace tel:, sin importar
// el número. Las tarjetas de tienda se inyectan dinámicamente con innerHTML y
// cada una tiene un href distinto (tel:${store.phone}); sin esto, Meta agrupa
// el clic por URL y crea un evento por cada número. Con un solo evento 'Call'
// fijo, todos los botones de llamada se trackean como el mismo evento.
document.addEventListener('click', function (e) {
  const target = e.target.closest('a');
  if (target && target.href && target.href.includes('tel:')) {
    if (typeof fbq === 'function') fbq('trackCustom', 'Call');
  }
});

// ===== INICIALIZACIÓN PRINCIPAL =====

document.addEventListener('DOMContentLoaded', async () => {
  // Propias y aliadas en paralelo: en la primera visita las dos van a la API.
  // Punto único de merge, después de los dos caminos (caché y fallback).
  const [, partners] = await Promise.all([initStoresData(), loadPartnerStores()]);
  ALLSTORES = ALLSTORES.concat(partners);
  initLocationSearchButton();

  const inputZip = document.getElementById('location-search');
  let debounceTimer;

  if (inputZip) {
    inputZip.addEventListener('input', function (e) {
      hideZipError();

      if (e.target.value.length > 5) {
        e.target.value = e.target.value.slice(0, 5);
      }

      const zipValue = e.target.value.trim();
      clearTimeout(debounceTimer);

      selectedPlace = null;
      if (submitZip) submitZip.disabled = true;

      if (zipValue.length === 5 && /^\d{5}$/.test(zipValue)) {
        // Ahora es síncrono — sin debounce necesario, pero lo mantenemos por UX
        debounceTimer = setTimeout(() => handleZipValidation(zipValue), 150);
      }
    });
  }

  const urlZipcode = getZipcodeFromURL();
  if (urlZipcode) {
    const waitForMap = setInterval(() => {
      if (map) {
        clearInterval(waitForMap);
        handleAutoSearch(urlZipcode);
      }
    }, 100);

    setTimeout(() => {
      clearInterval(waitForMap);
      if (!map) handleAutoSearch(urlZipcode);
    }, 5000);
  }
});
